import { Link } from "wouter";

export default function Footer() {
  return (
    <footer className="py-12 border-t border-stone-200 bg-white">
      <div className="container">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-teal-500 to-emerald-500 flex items-center justify-center">
              <svg
                className="h-4 w-4 text-white"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <circle cx="7" cy="20" r="2" />
                <circle cx="17" cy="20" r="2" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M17 18H7V9a4 4 0 014-4h2a4 4 0 014 4v3" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 9h14" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l2-4" />
              </svg>
            </div>
            <span className="text-sm text-stone-500">© 2026 SONOMAMA</span>
          </div>
          <nav className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-sm text-stone-500">
            <Link href="/stores" className="hover:text-stone-900 transition-colors">
              店舗検索
            </Link>
            <Link href="/articles" className="hover:text-stone-900 transition-colors">
              コラム
            </Link>
            <Link href="/contact" className="hover:text-stone-900 transition-colors">
              お問い合わせ
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
